module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_outlook-7b14d040b4304bca4635a9f49ca63ba6.png";